// Auth API client
import { BASE } from './../../config/setting';

/**
 * Login with email and password
 * Returns { user, token }
 */
export async function login(email, password) {
  try {
    const res = await fetch(`${BASE}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (!res.ok) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const error = await res.json();
        throw new Error(error.message || 'Login failed');
      } else {
        throw new Error(`Login failed: ${res.statusText}`);
      }
    }

    return await res.json();
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error(`Cannot connect to backend at ${BASE}. Make sure it's running.`);
    }
    throw error;
  }
}

/**
 * Verify current token
 */
export async function verifyToken(token) {
  try {
    const res = await fetch(`${BASE}/api/auth/verify`, {
      headers: { 
        'Authorization': `Bearer ${token}`
      }
    });

    if (!res.ok) {
      throw new Error('Token verification failed');
    }

    return await res.json();
  } catch (error) {
    throw error;
  }
}

/**
 * Request password reset (forgot password)
 */
export async function forgotPassword(email) {
  try {
    const res = await fetch(`${BASE}/api/auth/forget-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Failed to send reset link');
    }
    return data;
  } catch (error) {
    throw error;
  }
}

/**
 * Reset password using token
 */
export async function resetPassword({ token, newPassword }) {
  try {
    const res = await fetch(`${BASE}/api/auth/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, newPassword })
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Failed to reset password');
    }
    return data;
  } catch (error) {
    throw error;
  }
}
